import { render, staticRenderFns } from "./ConfirmAwarded.vue?vue&type=template&id=7e0490f0&"
import script from "./ConfirmAwarded.vue?vue&type=script&lang=js&"
export * from "./ConfirmAwarded.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports